module.exports = __webpack_public_path__ + "media/images/ticket/navi_events-8aa270c32fe1e837fa8980288b98e571.png";